import { useState } from "react";
import styles from "./DidYouKnowTip.module.css";

const DISMISSED_KEY = "beekeeper.dismissed_tips";

function getDismissed() {
  try {
    return new Set(JSON.parse(localStorage.getItem(DISMISSED_KEY) || "[]"));
  } catch {
    return new Set();
  }
}

/** Contextual "Did you know?" hint about an unlocked-but-unused feature.
 * `tipId` must be a stable, unique string so dismissal persists per tip. */
export function DidYouKnowTip({ tipId, children }) {
  const [dismissed, setDismissed] = useState(() => getDismissed().has(tipId));

  if (dismissed) return null;

  function dismiss() {
    const set = getDismissed();
    set.add(tipId);
    localStorage.setItem(DISMISSED_KEY, JSON.stringify([...set]));
    setDismissed(true);
  }

  return (
    <div className={styles.tip} role="note">
      <span aria-hidden="true">💡</span>
      <span className={styles.text}>
        <strong>Did you know?</strong> {children}
      </span>
      <button className={styles.close} onClick={dismiss} aria-label="Dismiss tip">✕</button>
    </div>
  );
}
